module.exports = "//static.hsappstatic.net/conversations-embed/static-1.23992/sass/messagesWidgetShell.sass"